import React, { useState } from "react";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { Typography } from "@mui/material";

export default function CustomerTestimonials(props) {
  const [openAddTestimonial, setOpenAddTestimonial] = useState(false);
  //const [testimonials, setTestimonials] = useState([]);

  function handleSubmit() {
    //does stuff
  }

  return (
    <>
      <Mobile>
        <Typography variant="h2">
          Customer Testimonials
          <span
            //href="http://technical-articles.hooverandstrong.com/wordpress/"
            //target="new"
            className="header-link"
          >
            Submit A Testimonial
          </span>
        </Typography>
        {/* Change here when testimonials are ready-- dont forget to delete the current styling */}
        <Typography sx={{ marginLeft: "1rem" }}>Coming Soon!</Typography>
      </Mobile>
      <Default>
        <div className="customer-testimonials">
          <Typography variant="h2">
            Customer Testimonials
            <span
              //href="http://technical-articles.hooverandstrong.com/wordpress/"
              //target="new"
              className="header-link"
            >
              Submit A Testimonial
            </span>
          </Typography>
          {/* Change here when testimonials are ready-- dont forget to delete the current styling */}
          <Typography sx={{ marginLeft: "1rem" }}>Coming Soon!</Typography>
        </div>
      </Default>
      <Dialog
        open={openAddTestimonial}
        onClose={() => setOpenAddTestimonial(false)}
      >
        <DialogTitle>Submit A Testimonial About This Product</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To subscribe to this website, please enter your email address here.
            We will send updates occasionally.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit}>Submit</Button>
          <Button onClick={() => setOpenAddTestimonial(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
